module.exports = __webpack_public_path__ + "static/11-72a067b757f093806ffb467eddf4e33d.jpg";